import { ArrowUpOutlined, CopyOutlined } from '@ant-design/icons';
import { Button, Col, Input, notification, Row, Tooltip } from 'antd';
import { cn } from 'cn';
import { Show } from '@/components/util/Show';
import { copyTextToClipboard } from '@/std/util';

type InputWithCopyButtonProps = {
    text_to_copy: string;
    style?: React.CSSProperties;
    showOpenNewTabBtn?: boolean;
    className?: string;
};

/**
 * esse cpte tem sua propria Row
 */
export function InputWithCopyButton(props: InputWithCopyButtonProps) {
    const { text_to_copy, showOpenNewTabBtn = false, style = {}, className } = props;

    const inputSize = showOpenNewTabBtn ? 20 : 24;

    return (
        <Row justify='space-between'>
            <Col lg={inputSize} md={inputSize} sm={inputSize} xs={inputSize}>
                <Input
                    className={cn('w-full', className)}
                    readOnly={true}
                    style={style}
                    suffix={
                        <Button
                            icon={
                                <Tooltip
                                    arrow={{ pointAtCenter: true }}
                                    placement='topRight'
                                    title='Copiar link para a área de transferência'
                                >
                                    <CopyOutlined style={{ fontSize: '14px' }} />
                                </Tooltip>
                            }
                            onClick={async () => {
                                const result = await copyTextToClipboard(text_to_copy);

                                if (result.error) {
                                    notification.error({
                                        description: result.error.message,
                                        title: 'Falha ao copiar',
                                    });

                                    return;
                                }

                                notification.success({
                                    description: 'Link copiado para a área de transferência',
                                    duration: 1.5,
                                    title: 'Feito!',
                                });
                            }}
                            size='small'
                            style={{
                                backgroundColor: 'rgba(0,0,0,0.3)',
                                borderRadius: '50%',
                                marginLeft: 5,
                            }}
                        />
                    }
                    value={text_to_copy}
                />
            </Col>

            <Show when={showOpenNewTabBtn}>
                <Col className='flex flex-row-reverse' lg={4} md={4} sm={4} xs={4}>
                    <Tooltip
                        arrow={{ pointAtCenter: true }}
                        placement='topRight'
                        title='Abrir link em outra aba'
                    >
                        <Button
                            onClick={() =>
                                window.open(text_to_copy, '_blank', 'noopener,noreferrer')
                            }
                            type='primary'
                        >
                            <ArrowUpOutlined rotate={45} />
                        </Button>
                    </Tooltip>
                </Col>
            </Show>
        </Row>
    );
}
